import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=205b8d6c"
import script from "./EditProfileForm.vue?vue&type=script&lang=ts"
export * from "./EditProfileForm.vue?vue&type=script&lang=ts"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=205b8d6c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports